import { gql } from "@apollo/client";
import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import useData from "hooks/useData";
import { Cog } from "mdi-material-ui";
import React from "react";
import ScorekeeperConfigsForm, { ScorekeeperConfigsFormFragment } from "readmin_pages/scorekeeper_configs/Form";

LeaguesScorekeeperConfigDialog.useButtonProps = () => {
  return {
    icon: <Cog />,
    content: "Edit Scorekeeper Settings",
  };
};

export default function LeaguesScorekeeperConfigDialog({ leagueIds, onSubmit, onClose }) {
  const [data, dataMeta] = useData(
    gql`
      query LeaguesScorekeeperConfigDialog($leagueIds: [ID!]!) {
        leagues(ids: $leagueIds) {
          id
          sport
          scorekeeperConfig {
            ...ScorekeeperConfigsFormFragment
          }
        }
      }
      ${ScorekeeperConfigsFormFragment}
    `,
    { leagueIds },
  );
  const leaguesUpdateScorekeeperConfig = useActionFragment("leaguesUpdateScorekeeperConfig");

  return (
    <FormDialog
      loading={dataMeta.loading}
      header="Edit Scorekeeper Settings"
      onClose={onClose}
      onSubmit={async (formData) => {
        await leaguesUpdateScorekeeperConfig({
          input: {
            leagueIds,
            scorekeeperConfigInput: {
              ...formData,
            },
          },
        });
        await onSubmit?.();
      }}
    >
      <ScorekeeperConfigsForm scorekeeperConfigs={data?.leagues.map((l) => l.scorekeeperConfig)} />
    </FormDialog>
  );
}
